(() => {
  const g = window;

  const whenReady = (fn) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  };

  const parseBool = (v) => String(v || '').toLowerCase() === 'true';

  const esc = (s) => String(s || '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#39;');

  const normalize = (s) => String(s || '').toLowerCase().trim();

  const buildUrlWithTag = (tag) => {
    const url = new URL(window.location.href);
    if (!tag) url.searchParams.delete('tag');
    else url.searchParams.set('tag', tag);
    return url.pathname + (url.searchParams.toString() ? `?${url.searchParams.toString()}` : '');
  };

  if (!g.__GLOSSARY_PILLS_INIT__) g.__GLOSSARY_PILLS_INIT__ = new WeakSet();
  const initialized = g.__GLOSSARY_PILLS_INIT__;

  const init = async (root) => {
    if (!root || initialized.has(root)) return;
    initialized.add(root);

    const Core = g.GlossaryCore;
    const row = root.querySelector('[data-pills-row]');
    const status = root.querySelector('[data-status]');
    if (!row) return;

    const setStatus = (t) => { if (status) status.textContent = t || ''; };

    row.innerHTML = '';
    setStatus('Loading…');

    if (!Core) {
      setStatus('GlossaryCore not loaded');
      return;
    }

    const token = (root.dataset.token || '').trim();
    const endpoint = (root.dataset.endpoint || '').trim();
    const type = (root.dataset.metaobjectType || '').trim();

    if (!token || !endpoint || !type) {
      setStatus(`Missing config: ${!token ? 'token ' : ''}${!endpoint ? 'endpoint ' : ''}${!type ? 'metaobject_type' : ''}`.trim());
      return;
    }

    const pageSize = Math.min(250, Math.max(10, parseInt(root.dataset.pageSize || '100', 10) || 100));
    const maxPills = Math.max(1, parseInt(root.dataset.maxPills || '24', 10) || 24);

    const colFilter = normalize(root.dataset.typeCollectionHandle || '');
    const baseTag = normalize(root.dataset.baseTag || '');
    const activeTag = normalize(root.dataset.tagParam || (new URL(window.location.href).searchParams.get('tag') || ''));

    const showAll = parseBool(root.dataset.showAllPill);
    const allLabel = (root.dataset.allLabel || 'All').trim();

    const tagsKey = (root.dataset.tagsFieldKey || 'tags').trim();
    const colKey = (root.dataset.collectionFieldKey || 'related_collection').trim();

    const counts = new Map();

    let after = null;
    let hasNext = true;
    let scanned = 0;
    let matched = 0;

    try {
      while (hasNext) {
        const json = await Core.sfFetch({
          endpoint,
          token,
          query: Core.METAOBJECTS_QUERY,
          variables: { type, first: pageSize, after }
        });

        const edges = json?.data?.metaobjects?.edges || [];
        const pageInfo = json?.data?.metaobjects?.pageInfo || {};
        after = pageInfo.endCursor || null;
        hasNext = !!pageInfo.hasNextPage;

        for (const e of edges) {
          const node = e?.node;
          if (!node) continue;

          scanned++;

          const f = Core.fieldsToMap(node.fields);
          const col = normalize(f[colKey]?.reference?.handle || '');

          if (colFilter && col !== colFilter) continue;

          const tags = Core.parseTags(f[tagsKey]?.value);
          if (baseTag && !tags.includes(baseTag)) continue;

          matched++;

          for (const t of tags) {
            const nt = normalize(t);
            if (!nt) continue;
            if (baseTag && nt === baseTag) continue;
            counts.set(nt, (counts.get(nt) || 0) + 1);
          }
        }
      }
    } catch (err) {
      setStatus(err?.message || 'Error loading pills');
      return;
    }

    let tags = Array.from(counts.entries()).map(([tag, count]) => ({ tag, count }));

    const sortMode = (root.dataset.sort || 'alpha').trim();
    if (sortMode === 'count') tags.sort((a, b) => b.count - a.count || a.tag.localeCompare(b.tag));
    else tags.sort((a, b) => a.tag.localeCompare(b.tag));

    tags = tags.slice(0, maxPills);

    const html = [];

    if (showAll) {
      html.push(`
        <a class="glossary-pill ${activeTag ? '' : 'is-active'}" href="${esc(buildUrlWithTag(''))}">
          ${esc(allLabel)}
        </a>
      `);
    }

    for (const t of tags) {
      const isActive = activeTag && normalize(activeTag) === normalize(t.tag);
      html.push(`
        <a class="glossary-pill ${isActive ? 'is-active' : ''}" href="${esc(buildUrlWithTag(t.tag))}">
          ${esc(t.tag)}
        </a>
      `);
    }

    row.innerHTML = html.join('');

    if (!html.length) {
      setStatus(`No tags found (scanned ${scanned}, matched ${matched}). Check tags field key "${tagsKey}" and filters.`);
    } else {
      setStatus('');
    }
  };

  const boot = () => {
    document.querySelectorAll('[data-glossary-pills]').forEach((el) => {
      init(el);
    });
  };

  whenReady(boot);

  document.addEventListener('shopify:section:load', (e) => {
    const roots = e.target.matches?.('[data-glossary-pills]')
      ? [e.target]
      : (e.target.querySelectorAll?.('[data-glossary-pills]') || []);
    roots.forEach((el) => init(el));
  });
})();
